import { CSSProperties, FunctionComponent, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Card } from "primereact/card";

import { translationKeys } from "../../../../models/app-translation-keys";
import { AiUsageWarning, TextMarkdown } from "../../Components";
import { CanDeactivatePendingChangesDialog } from "../../Components/Dialogs";

import "./FeatureLayout.scss";

interface IFeatureLayoutProps {
  titleKey: string;
  subTitleKey?: string;
  descriptionKey?: string;
  hasPendingChanges?: boolean;
  styles?: CSSProperties;
  children: ReactNode;
}

export const FeatureLayout: FunctionComponent<IFeatureLayoutProps> = (props: IFeatureLayoutProps) => {
  const { t } = useTranslation();

  return (
    <div className="feature-layout" style={props.styles}>
      <h1 className="feature-title">
        <span className="highlight">{t(props.titleKey)}</span>

        {!!props.subTitleKey && <small className="sub-title">{t(props.subTitleKey)}</small>}
      </h1>

      {!!props.descriptionKey && (
        <div className="feature-description">
          <Card>
            <TextMarkdown>{t(props.descriptionKey)}</TextMarkdown>
          </Card>
        </div>
      )}

      <div className="feature-content">{props.children}</div>

      <div className="feature-footer">
        <AiUsageWarning type="aiUsageInfo" />
      </div>

      <CanDeactivatePendingChangesDialog
        message={t(translationKeys.upload.summary.confirmStopProgressLeavePage)}
        rejectButtonText={t(translationKeys.actions.cancel)}
        acceptButtonText={t(translationKeys.actions.leavePage)}
        hasPendingChanges={props.hasPendingChanges || false}
      />
    </div>
  );
};
